import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import RichEditor from "../../components/editor/RichEditor";
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import SubTitle from "../../components/elements/SubTitle";
import AppAnimate from "../../components/AppAnimate/index";
import AppCard from "../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Button from "@material-ui/core/Button/Button";
import PageviewRoundedIcon from '@material-ui/icons/PageviewRounded';
import Hidden from "@material-ui/core/Hidden/Hidden";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import GetConfirmationText from "../../components/elements/GetConfirmationText";
import SizeChooser from "../../components/fields/SizeChooser";
import CoverChooser from "../../components/fields/CoverChooser";
import FieldCounterWithoutBar from "../../components/elements/FieldCounterWithoutBar";
import SingleImageChooser from "../fileManager/Components/SingleImageChooser";
import SingleFileChooser from "../fileManager/Components/SingleFileChooser";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import Alert from "@material-ui/lab/Alert/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Typography from "@material-ui/core/Typography/Typography";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
class MakeRevision extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();
    }
    state = {
        fields:{
            name:"",
            english_name:"",
            description:"",
            shop_id:this.props.user.role.type === "admin" ? this.props.primary_shop.id : this.props.user.shops.length ? this.props.user.shops[0].id : '',
            shop_name:'',
            price:'',
            priceR:'',
            discount_price:'',
            discount_priceR:'',
            priceWhole:'',
            priceWholeR:'',
            discount_priceWhole:'',
            discount_priceWholeR:'',
            inventory_for_wholesale:null,
            warranty:"",
            inventory:null,
            transfer_time:"",
            commission:'',
            weight:'',
            situation:'new',
            physically:'physical',
            publish_year:'',
            publish_turn:'',
            number_of_pages:null,
            isbn:null,
        },
        content:{
            HTML: '',
            RAW: null,
            PlainText: ''
        },
        initial_dialog:true,
        rating:4.5,
        advantages:[],
        disadvantages:[],
        thumbnail: null,
        back_cover: null,
        inside_pdf: null,
        brand_id: 0,
        label_id: 0,
        editor_input_text: '',
        is_not_original: 0,
        errors:{},
        keywords:[],
        categories:[],
        categoriesName:[],
        variables:[],
        variables_res:[],
        gallery: [],
        files: [],
        writers: [],
        translators: [],
        loading: true,
        SubmitLoading: false,
        checkLoading: false,
        publish: true,
        confirmed: true,
        has_wholesale: false,
        featured: false,
        slug: null,
        id:this.props.match.params.id,
        editMode:false,
        percent:'',
        percentWhole:'',
        owner_id:null,
        requested_to_delete:0,
        updated_at:null,
        created_at:null,
        book_file:null,
        size:null,
        cover_type:null,
        existed_product:null,
        no_shop:false,
        product_shop:null,
        product:null,
        is_changed:false,
    };
    classes = this.props.classes;
    componentDidMount(){

        if(this.state.id){
            this.setState({
                editMode:true,
                initial_dialog:false,
            })
            this.loadData();
        }else{
            this.setState({
                loading:false
            })
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(thumbnail){
        this.setState({
            thumbnail: thumbnail
        })
    }

    async loadData(){
            let loginToken = localStorage.getItem('ACT');
            if(loginToken !== null){
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                await axios.get(`${defaultVariabls.url}/product/get/${this.state.id}`, config)
                    .then(response => {
                        this.setState({
                            product:response.data
                        })
                        let categoriesTemp=[];
                        let categoriesNameTemp=[];
                        let galleryTemp=[];
                        let filesTemp=[];

                        response.data.categories.map(item => {
                            categoriesTemp.push(item.id)
                            categoriesNameTemp.push(item.name)
                            return true
                        })
                        response.data.gallery.map(item =>{
                            galleryTemp.push({
                                src: `${defaultVariabls.uploads}/FileManager/${item.name}_small.${item.extension}`,
                                id: item.id,
                                name: item.name,
                                type: item.type,
                            })
                            return true
                        })
                        response.data.files.map(item =>{
                            filesTemp.push({
                                id: item.id,
                                name: item.name,
                                type: item.type,
                            })
                            return true
                        })
                        this.setState({
                            categories: categoriesTemp,
                            categoriesName: categoriesNameTemp,
                            gallery: galleryTemp,
                            files: filesTemp,
                            loading: false
                        })
                    }).catch(error => {
                        console.log(error.response)
                        this.props.history.push('/');
                        this.props.enqueueSnackbar(Translate.pageNotFound, {
                            variant: 'error',
                        });
                        this.setState({
                            loading:false
                        })
                    })
            }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields,percent,percentWhole} = this.state;
        let target = e.target;
        if(target.name === "price"){
            fields.priceR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));

        }else if (target.name === "discount_price") {
            fields.discount_priceR = target.value.replace(/,/ig, '');
            if(!!fields.priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));
            if(parseInt(fields.discount_priceR) >= parseInt(fields.priceR)){
                fields.discount_price = '';
                fields.discount_priceR = '';
                percent = ''
            }
        }if(target.name === "priceWhole"){
            fields.priceWholeR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR)*100/fields.priceWholeR));

        }else if (target.name === "discount_priceWhole") {
            fields.discount_priceWholeR = target.value.replace(/,/ig, '');
            if(!!fields.priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR)*100/fields.priceWholeR));
            if(parseInt(fields.discount_priceWholeR) >= parseInt(fields.priceWholeR)){
                fields.discount_priceWhole = '';
                fields.discount_priceWholeR = '';
                percentWhole = ''
            }
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";
        this.setState({
            fields,
            percent,
            percentWhole,

        });
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;


        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 600) {
                formIsValid = false;
                errors['description'] = Translate.maxLength600;
            }
        }

        if(fields.discount_priceR !== null){
            if(fields.discount_priceR > 0){
                if(fields.discount_priceR >= fields.priceR){
                    formIsValid = false;
                    errors['discount_price'] = Translate.discountMoreThanPrice;
                }
            }
        }
        if(!!fields.inventory_for_wholesale){
            if(!fields.priceWholeR){
                formIsValid = false;
                errors['priceWhole'] = Translate.emptyField;
            }else if (fields.priceWholeR >= fields.priceR) {
                formIsValid = false;
                errors['priceWhole'] = Translate.wholesalePriceShouldBeLess;
            }
            if(!fields.inventory){
                formIsValid = false;
                errors['inventory'] = Translate.emptyField;
            }else if(parseInt(fields.inventory_for_wholesale) > parseInt(fields.inventory)){
                formIsValid = false;
                errors['inventory_for_wholesale'] = Translate.wholeSaleInventoryLessThanInventory;
            }
        }
        if(fields.discount_priceWholeR !== null){
            if(fields.discount_priceWholeR > 0){
                if(fields.discount_priceWholeR > fields.priceWholeR){
                    formIsValid = false;
                    errors['discount_priceWhole'] = Translate.discountMoreThanPrice;
                }
            }
        }
        if(!!fields.publish_year){
            if(parseInt(fields.publish_year) < 1000 && parseInt(fields.publish_year) > 3000){
                formIsValid = false;
                errors['publish_year'] = Translate.wrongYear;
            }
        }
        if(!formIsValid){
            console.log(errors);
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { id,fields,content,product,book_file,cover_type,writers,has_wholesale,inside_pdf,translators,size,featured,brand_id,label_id,thumbnail,back_cover,advantages,disadvantages,is_not_original,variables,editMode,gallery,files,categories,keywords,confirmed,publish} = this.state;
        let data = new FormData();
        data.append('product_id', id ? id : 0);
        if(!product.plainText){
            data.append('html', content.HTML);
            data.append('raw', content.RAW);
            data.append('plainText', content.PlainText);
        }
        data.append('description', fields.description);
        if(!product.thumbnail){
            data.append('thumbnail', !!thumbnail ? thumbnail.id : 1);
        }
        if(!product.back_cover){
            data.append('back_cover', !!back_cover ? back_cover.id : null);
        }
        if(!product.inside_pdf){
            data.append('inside_pdf', !!inside_pdf ? inside_pdf.id : null);
        }
        data.append('publish_year', fields.publish_year);
        data.append('publish_turn', fields.publish_turn);
        data.append('number_of_pages', fields.number_of_pages);
        data.append('cover_type', cover_type);
        data.append('size', size);
        if(gallery !== null){
            let galery_ids = [];
            gallery.map((row) =>{
                galery_ids.push(row.id);
                return true
            })
            gallery = JSON.stringify(galery_ids);
        }
        data.append('gallery', gallery);
        if(files !== null){
            let files_ids = [];
            files.map((row) =>{
                files_ids.push(row.id);
                return true
            })
            files = JSON.stringify(files_ids);
        }
        data.append('book_files', files);

        if(writers !== null){
            let writers_ids = [];
            writers.map((row) =>{
                writers_ids.push(row.id);
                return true
            })
            writers = JSON.stringify(writers_ids);
        }
        data.append('writers', writers);

        if(translators !== null){
            let translators_ids = [];
            translators.map((row) =>{
                translators_ids.push(row.id);
                return true
            })
            translators = JSON.stringify(translators_ids);
        }
        data.append('translators', translators);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let {user} = this.props;
        axios.post(`${defaultVariabls.url}/revision/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.revisionSent : Translate.revisionSent, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                this.props.history.push(`/dashboard`);
            })
            .catch(error => {
                console.log(error.response)
                if(error.response.status === 403){
                    this.props.enqueueSnackbar(Translate.youDidntMadeAnyChanges, {
                        variant: 'error',
                    });
                }else{
                    this.props.enqueueSnackbar(editMode ?  Translate.revisionSentFailed : Translate.revisionSentFailed, {
                        variant: 'error',
                    });
                }
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleCheckProduct(){
        let {fields,errors} = this.state;

        if(!!fields.isbn){
            if(fields.isbn.length === 10 || fields.isbn.length === 13){
                this.setState({
                    checkLoading:true
                });
                let data = new FormData();
                data.append('isbn', fields.isbn);
                data.append('physically', fields.physically);
                data.append('situation', fields.situation);


                let loginToken = localStorage.getItem('ACT');
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                let {user} = this.props;
                axios.post(`${defaultVariabls.url}/product/check`, data, config)
                    .then(response => {
                        let result = response.data;
                        if(parseInt(result.isbn) === 0){
                            errors['isbn'] = Translate.wrongISBN;
                            this.setState({
                                checkLoading:false,
                                errors
                            })
                        }else{
                            fields.isbn = result.isbn
                            if(result.product === null){
                                this.setState({
                                    initial_dialog:false,
                                    checkLoading:false,
                                    fields,
                                })
                            }else{
                                this.setState({
                                    existed_product:result.product,
                                    checkLoading:false,
                                    fields,
                                })
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error.response)
                        this.setState({
                            checkLoading: false,
                        });
                    });
            }else{
                errors['isbn'] = Translate.wrongISBN;
                this.setState({
                    errors
                });
            }
        }else{
            this.setState({
                initial_dialog:false,
            })
        }
    }
    handleClickDescription(){
        let {fields,content} = this.state;
        if(fields['description'] === ''){
            fields['description'] = content.PlainText === null ? null : content.PlainText.slice(0, 150);
            this.setState({fields})
        }
    }
    handleSubmit(e,draft = false){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.setState({
                    publish:draft
                })
                this.handleRequest();
            }
        });
    }

    handleOutPut(code){
        this.setState({
            content:code
        })
    }
    handleCategoryHolder(categories){
        this.setState({categories})
    }
    handleVariablesHolder(variables){
        this.setState({variables})
    }
    handleGalleryChange(data){
        this.setState({
            gallery: data,
        })
    }
    handleFilesChange(data){
        this.setState({
            files: data,
        })
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    handleChangeFeatured(){
        this.setState({
            featured: !this.state.featured,
        })
    }
    async handleRequestToDelete(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/product/request_delete/${this.state.id}`, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.requestedToDelete, {
                    variant: 'success',
                });
                this.setState({
                   requested_to_delete:1,
                })
            }).catch(error => {
                console.log(error.response)
            })
    }
    handleDeleteProduct(){
        let data = new FormData();
        data.append('id', this.state.id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/delete/product`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteProduct, {
                    variant: 'success',
                });
                this.props.history.push('/manage/products')
                return true
            })

            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteProductFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    async changeCategories(){
        await this.setState({
            categoriesName:[],
            categories:[],
            variables:[],
        })
    }
    render(){
        let {fields,brand_id,label_id,percent,rating,product,featured,has_wholesale, percentWhole,errors,writers,translators,initial_dialog,gallery,files,slug,checkLoading,SubmitLoading,keywords,thumbnail,back_cover,inside_pdf,categories,categoriesName,content,editMode,confirmed,editor_input_text} = this.state;
        const {user,primary_shop} = this.props;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.sendRevision}>
            {
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <Grid container spacing={2} justifyContent="center">
                                    <Grid item xs={12}>
                                        <AppCard
                                            title={Translate.sendRevision}
                                            action={
                                                <BreadCrumbs singleLevel firstText={Translate.sendRevision}/>
                                            }>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} justifyContent="center" alignItems="center" style={{marginBottom:10}}>
                                                        <Grid item xs={12}>
                                                            <Alert
                                                                severity="warning"
                                                                action={
                                                                   <Button color="inherit" size="small" variant="contained" component={Link} to={`/create/product`} style={{whiteSpace:"nowrap"}}>
                                                                       {Translate.createProduct}
                                                                   </Button>
                                                               }
                                                            >
                                                                <AlertTitle>{Translate.revisionAlertTitle}</AlertTitle>
                                                                {Translate.revisionAlertText}
                                                            </Alert>
                                                        </Grid>
                                                        {
                                                            (initial_dialog === false && (product.isbn !== 0 && !!product.isbn)) &&
                                                            <Grid item xs={12}>
                                                                <div style={{display:"flex",alignItems:"center"}}>
                                                                    <Typography style={{marginLeft:10}}>{Translate.isbn}: <strong>{product.isbn}</strong></Typography>
                                                                    {/*
                                                                        <Typography>{Translate[fields.physically]}</Typography>
                                                                        */}
                                                                    {
                                                                        product.physically === "physical" &&
                                                                        <Typography>{Translate.situation}: <strong>{Translate[product.situation]}</strong></Typography>
                                                                    }
                                                                </div>


                                                            </Grid>
                                                        }
                                                        {
                                                            (initial_dialog === false && !product.isbn) &&
                                                            <Grid item xs={12}>
                                                                <div style={{display:"flex",alignItems:"center"}}>

                                                                    <Typography style={{marginLeft:10}}>{Translate.isbn}: <strong>{Translate.isNotExist}</strong></Typography>
                                                                    {/*
                                                                    <Typography>{Translate[fields.physically]}</Typography>
*/}
                                                                    {
                                                                        product.physically === "physical" &&
                                                                        <Typography>{Translate.situation}: <strong>{Translate[product.situation]}</strong></Typography>
                                                                    }
                                                                </div>
                                                            </Grid>
                                                        }

                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.bookInformation}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                required
                                                                size="small"
                                                                fullWidth
                                                                name="name"
                                                                variant="outlined"
                                                                label={Translate.productName}
                                                                placeholder={Translate.productName}
                                                                type="text"
                                                                id="name"
                                                                disabled={!!product.name}
                                                                value={!!product.name ? product.name : fields.name}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['name']}
                                                                helperText={errors['name']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={!!product.number_of_pages ? product.number_of_pages : fields.number_of_pages}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                disabled={!!product.number_of_pages}
                                                                label={Translate.number_of_pages}
                                                                name="number_of_pages"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['number_of_pages']}
                                                                helperText={errors['number_of_pages']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={!!product.publish_year ? product.publish_year :fields.publish_year}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                label={Translate.publish_year}
                                                                name="publish_year"
                                                                disabled={!!product.publish_year}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['publish_year']}
                                                                helperText={errors['publish_year']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={!!product.publish_turn ? product.publish_turn :fields.publish_turn}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                disabled={!!product.publish_turn}
                                                                label={Translate.publish_turn}
                                                                name="publish_turn"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['publish_turn']}
                                                                helperText={errors['publish_turn']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <SizeChooser
                                                                disabled={!!product.size}
                                                                input={!!product.size ? product.size : this.state.size}
                                                                output={(size) => this.setState({size})}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}  md={6}>
                                                            <CoverChooser
                                                                disabled={!!product.cover_type}
                                                                input={!!product.cover_type ? product.cover_type : this.state.cover_type}
                                                                output={(cover_type) => this.setState({cover_type})}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                            this.state.loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <SubTitle align="left">{Translate.productDescription}</SubTitle>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <RichEditor
                                                            inputText={editor_input_text}
                                                            ref={this.EditorChild}
                                                            Output={this.handleOutPut.bind(this)}
                                                            input={!!product.plainText ? product.raw : content.RAW}
                                                            disabled={!!product.plainText}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            multiline
                                                            fullWidth
                                                            disabled={!!product.description}
                                                            name="description"
                                                            label={Translate.seoDescription}
                                                            placeholder={Translate.seoDescription}
                                                            type="text"
                                                            id="description"
                                                            minRows="4"
                                                            value={!!product.description ? product.description : fields.description}
                                                            onChange={this.handleChange.bind(this)}
                                                            onClick={this.handleClickDescription.bind(this)}
                                                            error={!!errors['description']}
                                                            helperText={errors['description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.description.length} max={600}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    {/*<Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.keywordsLabel}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Keywords input={keywords}
                                                                      handleChange={(keywords) => this.setState({keywords})}/>
                                                            <Typography
                                                                variant="body2"
                                                                style={{marginTop: 10, fontWeight: 700}}
                                                            >
                                                                {Translate.keywordsDescription}
                                                                <br/>
                                                            </Typography>
                                                            <Typography>
                                                                {Translate.pressEnterAfterEachKeyword}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>*/}
                                    <Hidden smDown>
                                        <Grid item xs={12}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                onClick = {this.handleSubmit.bind(this)}
                                                loading = {SubmitLoading}
                                            >
                                                {Translate.sendRevision}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2} alignItems="center" justify="center">
                                    <Hidden smDown>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                styleForParent={{marginBottom:10}}
                                                style={{width: "100%"}}
                                                onClick={this.handleSubmit.bind(this)}
                                                loading={SubmitLoading}
                                            >
                                                {Translate.sendRevision}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.front_cover}</SubTitle>
                                                            <SingleImageChooser
                                                                primary
                                                                onChange={(thumbnail) => this.handleThumbImage(thumbnail)}
                                                                initial={!!product.thumbnail ? product.thumbnail : thumbnail}
                                                                disabled={!!product.thumbnail}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.back_cover}</SubTitle>
                                                            <SingleImageChooser
                                                                primary
                                                                onChange={(back_cover) => this.setState({back_cover})}
                                                                initial={!!product.back_cover ? product.back_cover : back_cover}
                                                                disabled={!!product.back_cover}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SingleFileChooser
                                                                title={Translate.inside_pdf}
                                                                initial={!!product.inside_pdf ? product.inside_pdf : inside_pdf}
                                                                disabled={!!product.inside_pdf}
                                                                onChange={(file) => this.setState({inside_pdf:file})}
                                                                type="document"
                                                                align="center"
                                                            />
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Hidden mdUp>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <LoadingButton
                                                variant="contained"
                                                color="primary"
                                                styleForParent={{marginBottom:10}}
                                                style={{width: "100%"}}
                                                onClick={this.handleSubmit.bind(this)}
                                                loading={SubmitLoading}
                                            >
                                                {Translate.sendRevision}
                                            </LoadingButton>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Grid>
                        </Grid>

                }
            </AppAnimate>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,

});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeRevision))));